// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__4edoY","right":"styles_right__M6bnD"};